import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Table, Box, CircularProgress, IconButton, InputAdornment, TableBody, AppBar, Typography, Toolbar, TableCell, TableContainer, TableHead, TableRow, Modal, Paper } from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import { useNavigate, useParams } from 'react-router-dom';
import base64 from 'base64-js';
import Tooltip from '@mui/material/Tooltip';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from "@mui/icons-material/Search";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const Concession = () => {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [concessionDetails, setConcessionDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [selectedConcession, setSelectedConcession] = useState({ concessionId: null, concessionName: '', remark: '' });
  const [showModal, setShowModal] = useState(false);
  const [authorization, setAuthorization] = useState(null);
  const navigate = useNavigate();
  const { encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const formId = decodeFormId(encodedFormId);

  const handleAddConcession = () => {
    if (authorization?.uWrite === 1) {
      navigate('/addconcession');
    } else {
      // alert("You are not authorized to add a concession.");
      setSnackbarMessage('You are not authorized to add a concession.');
        setOpenSnackbar(true);
        setSnackbarSeverity('warning');
    }
  };

  const handleShow = (concessionId, concessionName) => {
    if (authorization?.uDelete === 1) {
      setSelectedConcession({ concessionId, concessionName });
      setShowModal(true);
    } else {
      // alert("You are not authorized to delete.");
      setSnackbarMessage('You are not authorized to delete.');
        setOpenSnackbar(true);
        setSnackbarSeverity('warning');
    }
  };

  const handleEdit = (concessionId) => {
    if (authorization?.uModify === 1) {
      navigate(`/editconcession/${concessionId}`);
    } else {
      // alert("You are not authorized to edit.");
      setSnackbarMessage('You are not authorized to edit.');
        setOpenSnackbar(true);
        setSnackbarSeverity('warning');
    }
  };

  const handleDelete = async () => {
    try {
      const token = sessionStorage.getItem('token');
      setLoadingBarProgress(30);
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Concession/Id?Id=${selectedConcession.concessionId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (response.ok) {
        setShowModal(false);
        setLoadingBarProgress(100);
        fetchConcessionData();
        setSnackbarMessage('Concession deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity('success');
        
      } else {
        setLoadingBarProgress(0);
        console.error('Delete failed');
        // alert('Failed to delete concession');
        setSnackbarMessage('Failed to delete concession');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
    }
  };

  const handleClose = () => {
    setSelectedConcession({ concessionId: null, concessionName: '', remark: '' });
    setShowModal(false);
  };

 const fetchConcessionData = async () => {
  try {
    setIsLoading(true); // Start loading
    const url = process.env.REACT_APP_BASE_URL;
    const apiUrl = `${url}/Concession/GetConcession`;
    const token = sessionStorage.getItem('token');
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    if (!response.ok) {
      throw new Error(`Error fetching concession data: ${response.status}`);
    }
    const concessionData = await response.json();
    if (concessionData.data === null && concessionData.msg === "Record Not Found") {
      console.error('Record Not Found');
      // alert('Record Not Found');
       setSnackbarMessage('Record Not Found');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
      return;
    }
    setConcessionDetails(concessionData);
  } catch (error) {
    console.error('API request error:', error);
    // alert('An error occurred. Please try again later.');
     setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
  } finally {
    setIsLoading(false); // Stop loading
  }
};


  const Authorizer = async () => {
    if (!formId) {
      console.error("formId is null, cannot call Authorizer");
      setAuthorization({ isPermission: 0 });
      return;
    }
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/CPanel/Module_Authorizer`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          formId,
        }),
      });
      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData[0]);
      } else {
        console.error('Authorizer request failed');
        setAuthorization({ isPermission: 0 });
      }
    } catch (error) {
      console.error('API request error:', error);
      setAuthorization({ isPermission: 0 });
    }
  };

  useEffect(() => {
    if (formId) {
      Authorizer();
      fetchConcessionData();
    } else {
      setAuthorization({ isPermission: 0 });
    }
  }, [formId]);

  if (!authorization) {
    return <div>Loading...</div>;
  }

  if (authorization.isPermission !== 1 || !formId) {
    return <div>You are not authorized to view this page</div>;
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };

  const filteredData = concessionDetails
    .filter((concession) => concession.concessionName.toLowerCase().includes(searchTerm.toLowerCase()));
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Concession Details
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', margin: "10px auto" }}>
          <TextField
            label="Search"
            variant="outlined"
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}

            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Tooltip title={authorization.uWrite === 1 ? "" : "You are not authorized to add"} arrow>
            <span>
              <Button
                variant="contained"
                color="primary"
                style={{
                  width: "160px",
                  height: "50px", // match TextField height
                  padding: "10px 0", // vertical padding similar to TextField
                }}

                onClick={handleAddConcession}
                disabled={authorization.uWrite !== 1}
              >
                Add Concession
              </Button>
            </span>
          </Tooltip>
        </div>
        <TableContainer component={Paper} style={{ marginTop: 16 }}>
          <Table
            stickyHeader
            sx={{
              minWidth: 650,
              border: '1px solid #ccc',
              '& .MuiTableCell-root': {
                borderRight: '1px solid #ccc',
                fontSize: '1rem',
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Concession Name
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Remark
                </TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc', textAlign: 'center', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
  {isLoading ? (
    <TableRow>
      <TableCell colSpan={3} align="center">
        <CircularProgress />
      </TableCell>
    </TableRow>
  ) : paginatedData.length > 0 ? (
    paginatedData.map((concession) => (
      <TableRow key={concession.concessionId} sx={{ borderTop: '1px solid #ccc' }}>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          {concession.concessionName}
        </TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          {concession.remark || "N/A"}
        </TableCell>
        <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          <Tooltip title={authorization.uModify === 1 ? "" : "You are not authorized to edit"} arrow>
            <span>
              <Button
                variant="contained"
                color="warning"
                onClick={() => handleEdit(concession.concessionId)}
                disabled={authorization.uModify !== 1}
                sx={{ marginRight: 1 }}
                startIcon={<EditIcon />}
              >
                Edit
              </Button>
            </span>
          </Tooltip>
          <Tooltip title={authorization.uDelete === 1 ? "" : "You are not authorized to delete"} arrow>
            <span>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleShow(concession.concessionId, concession.concessionName)}
                disabled={authorization.uDelete !== 1}
                sx={{ marginRight: 1 }}
                startIcon={<DeleteIcon />}
              >
                Delete
              </Button>
            </span>
          </Tooltip>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={3} align="center">
        No Concession Details Found
      </TableCell>
    </TableRow>
  )}
</TableBody>

          </Table>
        </TableContainer>

        {filteredData.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{
                native: true,
              }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>

            <Box>
              <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ mr: 1 }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}



        <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
              <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                Delete Confirmation ⚠️
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: '20px' }}>
              <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                Are you sure you want to delete concession for <strong>{selectedConcession?.concessionName}</strong>?
              </Typography>

              {/* Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  Yes, Delete
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default Concession;
